import React from 'react';

/*
 * The organization selector dropdown lets the user switch their current and/or default organization.
 * It can either be passed a full array of {id, name} organizations in the 'values' prop or it can
 * retrieve the list itself with a userId and orgList. In either case, it should be passed an orgChangeFn 
 * function, a setDefault boolean, and optionally a selectedOrg to start with (it is *strongly* 
 * recommended that you not leave this up to chance!)
 */
class OrgSelect extends React.Component {
	constructor(props) {
		super(props);
		
		// State management:
		this.state = {
			value: this.props.selectedOrg || '',
			error: false,
			isLoaded: false,
			items: false
		};
		
		// Function bindings:
		this.handleChange = this.handleChange.bind(this);
		this.fetchData = this.fetchData.bind(this);
	}
	
	handleChange(event) {
		this.props.orgChangeFn(event.target.value, this.props.setDefault);
		this.setState({ value: event.target.value });
	}
	
	fetchData() {
		// Build Org list
		var orgSelected = this.state.value;
		
		if (this.props.values) { // Values provided wholesale
			if (!this.props.values.length) { // Base case: there are no values. (likely not finished loading)
				this.setState({
					error: false,
					isLoaded: false,
					items: false
				});
				
				return;
			}
			
			const userOrgs = this.props.values.map((org) => {
					// Default to selecting the first Org
					if (!orgSelected) {
						orgSelected = true;
						this.handleChange({ target: { value: org.id } });
					}
					
					return <option value={org.id} key={org.id} >{org.name.substring(0, 50)}</option>;
				}
			);
			
			this.setState({
				error: false,
				isLoaded: true,
				items: userOrgs
			});
		}
		else { // Retrieve values from API 
			if (this.props.userId && this.props.orgList && this.props.orgList.length) { // TODO: fetch request when backend supports it.
				fetch('webpub-services/WPUserOrganizationAPI/getOrganizationsByWPUser/' + this.props.userId, 
					{
						method: 'GET'
					}
				)
				.then(res => res.json())
				.then(
					(result) => {
						if (result.length && result[0].accessLevel) { // Data is formatted as expected
							const userOrgs = result.map((userOrg) => {
								// Default to selecting the first Org
								if (!orgSelected) {
									orgSelected = true;
									this.handleChange({ target: { value: userOrg.organizationId } });
								}
								
								const organizationItem = this.props.orgList.filter(org => org.id === userOrg.organizationId)[0];
								
								return (
									<option 
										value={userOrg.organizationId} 
										key={userOrg.organizationId} 
									>
										{organizationItem.name.substring(0, 50)}
									</option>
								);
							})
							
							
							this.setState({
								error: false,
								isLoaded: true,
								items: userOrgs
							});
						}
					},
					
					(error) => {
						this.setState({ // Something went wrong!
							error: error,
							isLoaded: false,
							items: false
						});
					}
				);
			}
			else {
				this.setState({ // Listen, if you're not going to take this seriously...
					error: {message: 'Required parameters not found (OS75)'},
					isLoaded: false,
					items: false
				});
			}
		}
	}

	// Initial page load
	componentDidMount() {
		this.fetchData();
	}
	
	// Refresh components on state change
	componentDidUpdate(prevProps, prevState) {
		if (this.props.selectedOrg !== prevProps.selectedOrg 
				|| this.props.userId !== prevProps.userId 
				|| this.props.values !== prevProps.values
			) {
			// Props have changed. Send new fetch request
			if (this.props.selectedOrg) { // Make sure we select the right Org!
				this.setState({
					value: this.props.selectedOrg
				}, this.fetchData());
			}
			else {
				this.fetchData();
			}
		}
	}
	
	render() {
		if (this.state.error) {
			return <div className='error-text'>
				Error: {
					this.state.error.message 
					? this.state.error.message 
					: 'An unknown error has occurred (OS97)'
				}
			</div>;
		} else if (!this.state.isLoaded) { // Display nothing until we're ready for user input
			return <div></div>
		}
	
		return (
			<div className='page-level-dropdown' >
				<form>
					<select value={this.state.value} onChange={this.handleChange} >
						{this.state.items}
					</select>
				</form>
			</div>
		);
	}
}

export default OrgSelect;